export default[
    {id:1, name:'BMW',price:110},
    {id:2, name:'Google',price:210},
    {id:3, name:'Apple',price:280},
    {id:4, name:'IBM',price:80},
]